function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 1467",
  width: 19,
  height: 3,
  rx: 1.5,
  fill: "#333d42"
});

var SvgIconMinus = function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 3
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMTkgMyI+CiAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNDY3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDY3IiB3aWR0aD0iMTkiIGhlaWdodD0iMyIgcng9IjEuNSIgZmlsbD0iIzMzM2Q0MiIvPgo8L3N2Zz4K";
export { SvgIconMinus as ReactComponent };